export default __webpack_public_path__ + "static/media/zoo.6fe08116.jpg";